// erp有需要特殊处理数据的在这里统一处理

export default {
  // 登录
  handleUserData(data) {
    const res = {};
    res.userInfo = Object.assign({},  data.LIST[0]);
    res.menuList = data.MENULIST;
    res.fileList = data.FILELIST;
    res.sysList = data.SYSLIST;
    res.cityList = data.CITYLIST;
    res.auth = data.OPTIONLIST
    const menuList = [];
    data.MENULIST.forEach(item =>{
      if(item.ASSEMBLY){
        menuList.push(item)
      }
    })
    res.menuTree = this.arrayToTree(menuList, {
      idField: 'MENU_ID',
      parentField: 'PARENT_MENU_ID',
      sortField: 'MENU_ORDER',
      each: (menu, parent) => {
        // 添加权限
        menu.role = data.OPTIONLIST.filter(role => role.MENU_ID === menu.MENU_ID);
        // 添加filter
        menu.fullName = (parent ? `${parent.fullName} / ` : '') + menu.MENU_NAME;
        menu.fullFilter = (parent ? `${parent.fullFilter} / ` : '') + menu.FILTER;

        if(!/^\//.test(menu.ASSEMBLY)){
          menu.ASSEMBLY = (parent ? `${parent.ASSEMBLY}/` : '/') + menu.ASSEMBLY
        }
      }
    });
    return res;
  },

  arrayToTree(array, { idField = 'id', parentField = 'parent', sortField = 'sort', childrenField = 'children', isLeafField = 'isLeaf', each } = {}) {
    array.sort((a, b) => a[sortField] > b[sortField] ? 1 : -1);
    let rootList = [], nodeMap = {};
    let once = (node) => {
      if (!nodeMap[node[idField]]) {
        node[childrenField] = [];
        nodeMap[node[idField]] = node;

        if (node[parentField]) {
          if (!nodeMap[node[parentField]]) {
            let parentNode = array.find(item => item[idField] === node[parentField]);
            if (parentNode) {
              once(parentNode);
            } else {
              rootList.push(node);
            }
          }

          if (nodeMap[node[parentField]]) {
            nodeMap[node[parentField]][childrenField].push(node);
          }
        } else {
          rootList.push(node);
        }

        if (typeof each === 'function') {
          each(node, nodeMap[node[parentField]]);
        }
      }
    };

    array.forEach(item => once(item));

    array.forEach(item => {
      item[isLeafField] = item[childrenField].length === 0;
    });

    return rootList;
  }
};
